import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useIntl } from 'react-intl';

import { Icon } from '@verantos-dev/shared-components';

export const CohortSubjects = ({ subjectCount }: { subjectCount: number }) => {
  const intl = useIntl();
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        mr: theme.spacing(5),
      }}
    >
      <Box sx={{ width: '16px', height: '16px', marginRight: `${theme.spacing(1)}` }}>
        <Icon id={'cohort-info-bar-owner-icon'} icon={'subjectsCount'} />
      </Box>
      <Typography variant="body2">
        {intl.formatMessage({
          id: 'projects.cohortBuilderPage.components.cohortInfoBar.subjects',
        })}
        :&nbsp;
      </Typography>
      <Typography variant="body2" color={`${theme.palette.text.primary}`}>
        {subjectCount >= 0 ? intl.formatNumber(subjectCount) : '--'}
      </Typography>
    </Box>
  );
};
